import { Search, PanelLeftClose } from 'lucide-react';
import { useAppStore } from '@/store/appStore';
import { useOrganization } from '@/context/OrganizationContext';
import { OrgSwitcher } from './OrgSwitcher';
import { isTauriMacOS } from '@/utils/platform';

interface SidebarHeaderProps {
  isCollapsed: boolean;
  onToggleCollapse: () => void;
  onClose?: () => void;
  onCreateOrg?: () => void;
  onOrgSettings?: () => void;
}

export function SidebarHeader({ isCollapsed, onToggleCollapse, onClose, onCreateOrg, onOrgSettings }: SidebarHeaderProps) {
  const isMobile = useAppStore((state) => state.isMobile);
  const openCommandPalette = useAppStore((state) => state.openCommandPalette);
  const { currentOrg } = useOrganization();

  const orgName = currentOrg?.name ?? 'Zenda';

  const macTrafficLightPadding = isTauriMacOS();

  if (isCollapsed) {
    return (
      <div
        className="p-4 flex items-center justify-center"
        style={macTrafficLightPadding ? { paddingTop: 38 } : undefined}
        data-tauri-drag-region=""
      >
        <div className="w-6 h-6 rounded-md bg-gradient-to-br from-accent-violet to-accent-blue flex items-center justify-center shadow-sm">
          <span className="text-[10px] font-bold text-white">{orgName[0]?.toUpperCase() ?? 'Z'}</span>
        </div>
      </div>
    );
  }

  return (
    <div
      className="px-3 pt-3 pb-3"
      style={macTrafficLightPadding ? { paddingTop: 38 } : undefined}
      data-tauri-drag-region=""
    >
      <div className="flex items-center justify-between">
        {onCreateOrg && onOrgSettings ? (
          <OrgSwitcher onCreateOrg={onCreateOrg} onOrgSettings={onOrgSettings} />
        ) : (
          <div className="flex items-center gap-2.5 px-1 min-w-0">
            <div className="w-7 h-7 rounded-lg bg-gradient-to-br from-accent-violet to-accent-blue flex items-center justify-center shadow-sm flex-shrink-0">
              <span className="text-[10px] font-bold text-white">{orgName[0]?.toUpperCase() ?? 'Z'}</span>
            </div>
            <span className="text-[14px] font-semibold text-text-primary truncate">
              {orgName}
            </span>
          </div>
        )}

        <div className="flex items-center gap-1">
          {!isMobile && (
            <button
              onClick={onToggleCollapse}
              className="p-1.5 rounded-md hover:bg-surface-hover transition-colors text-text-quaternary hover:text-text-tertiary"
              title="Chiudi sidebar"
            >
              <PanelLeftClose className="w-4 h-4" />
            </button>
          )}
          <button
            onClick={openCommandPalette}
            className="p-1.5 rounded-md hover:bg-surface-hover transition-colors text-text-quaternary hover:text-text-tertiary"
            title="Cerca (⌘K)"
          >
            <Search className="w-4 h-4" />
          </button>
          {isMobile && (
            <button
              onClick={onClose}
              className="p-1.5 rounded-md hover:bg-surface-hover transition-colors text-text-quaternary hover:text-text-tertiary md:hidden"
              title="Chiudi navigazione"
            >
              <PanelLeftClose className="w-4 h-4" />
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
